<template>
    <div class="btn-group" style="width: 100%;" ref="container">
        <button
            type="button"
            class="multiselect dropdown-toggle btn btn-light"
            :class="{ open: isOpen }"
            style="width: 100%; overflow: hidden; text-overflow: ellipsis;"
            @click="toggleDropdown"
        >
            <span class="multiselect-selected-text" v-if="modelValue.length">{{ selectedText }}</span>
            <span class="multiselect-selected-text text-muted" v-else>{{ $t('labels.empty') }}</span>
        </button>
        <div class="multiselect-container dropdown-menu" :class="{ show: isOpen }">
            <template v-for="group in groups" :key="group.name">
                <div class="multiselect-item multiselect-group form-check dropdown-item" :class="{ active: isGroupSelected(group) }">
                    <label class="form-check-label">
                        <input
                            type="checkbox"
                            :checked="isGroupSelected(group)"
                            @change="toggleGroup(group)"
                        >
                        <span class="form-check-control-indicator"></span> {{ group.name }}
                    </label>
                </div>
                <div
                    v-for="item in group.items"
                    :key="item.value"
                    class="multiselect-item dropdown-item form-check"
                    :class="{ active: isSelected(item[optionValue]) }"
                >
                    <label class="form-check-label" @click.prevent="toggleItem(item[optionValue])">
                        <AppCheckbox
                            :modelValue="isSelected(item[optionValue])"
                            class="ml-2"
                        />
                        {{ item[optionKey] }}
                        <span class="form-check-control-indicator"></span>
                    </label>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import AppCheckbox from '../../../components/new/form/checkbox/AppCheckbox.vue';

export default {
    name: "AppGroupSelect",
    props: {
        groups: {
            type: Array,
            default: () => []
        },
        modelValue: {
            type: Array,
            default: () => []
        },
        optionValue: {
            type: String,
            default: 'uuid'
        },
        optionKey: {
            type: String,
            default: 'name'
        }
    },
    components: {
        AppCheckbox
    },
    emits: ['update:modelValue'],
    data() {
        return {
            isOpen: false
        }
    },
    computed: {
        selectedText() {
            return this.groups
                .flatMap(g => g.items)
                .filter(item => this.modelValue.includes(item[this.optionValue]))
                .map(i => i[this.optionKey]).join(', ');
        }
    },
    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        isSelected(value) {
            return this.modelValue.includes(value);
        },
        isGroupSelected(group) {
            return group.items.length > 0 && group.items.every(item => this.modelValue.includes(item[this.optionValue]));
        },
        toggleItem(value) {
            const newValue = this.isSelected(value)
                ? this.modelValue.filter(v => v !== value)
                : [...this.modelValue, value];
            this.$emit('update:modelValue', newValue);
        },
        toggleGroup(group) {
            const groupValues = group.items.map(i => i[this.optionValue]);
            const newValue = this.isGroupSelected(group)
                ? this.modelValue.filter(v => !groupValues.includes(v))
                : [...new Set([...this.modelValue, ...groupValues])];
            this.$emit('update:modelValue', newValue);
        },
        onClickOutside(event) {
            if (!this.$refs.container.contains(event.target)) {
                this.isOpen = false;
            }
        }
    },
    mounted() {
        document.addEventListener('click', this.onClickOutside);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.onClickOutside);
    }
}
</script>